module.exports = __webpack_public_path__ + "img/lingyu1.2065688e.webp";